import React from 'react';
const variants = {
  primary: 'bg-eddp-primary hover:bg-green-800 text-white shadow-slick',
  secondary: 'bg-white text-eddp-dark border border-slate-200 hover:bg-slate-50 shadow-sm',
  accent: 'bg-eddp-accent text-eddp-dark hover:bg-lime-500 font-semibold shadow-slick',
  ghost: 'bg-transparent text-eddp-muted hover:text-eddp-dark hover:bg-slate-100',
};
export const Button = ({ children, variant = 'primary', className = '', ...props }) => {
  return (
    <button 
      className={`${variants[variant]} px-4 py-2 rounded-lg transition-all duration-200 flex items-center justify-center gap-2 active:scale-95 ${className}`}
      {...props}
    >
      {children}
    </button>
  );
};
